import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { slotModel } from "slotworks/model/slot-model";
import { RadioControl } from "./radio-control";

export class AutoSpinsCountRadioControl extends RadioControl {

    constructor(protected buttons: FlexiButton[], protected labels: FlexiText[], protected leftArrow?: FlexiButton, protected rightArrow?: FlexiButton) {
        super(buttons, labels, leftArrow, rightArrow);

        this.setFormatMethod((input: number) => {
            if (input === Infinity) {
                return Services.translations.getFirstValid(["infinity", "curr.inf"]);
            } else {
                return input.toString();
            }
        });
        const autoplays = slotModel.read().autoplay.autoplays;
        autoplays.currentValue = undefined;
        this.setValues(autoplays.values, autoplays.currentValue);
        this.onChange(autoplays.values.indexOf(autoplays.currentValue), autoplays.currentValue);
    }

    protected onChange(index: number, value: number): void {
        super.onChange(index, value);

        const autoplay = slotModel.read().autoplay;

        autoplay.autoplays.currentValue = value;

        slotModel.write({ autoplay });
    }
}
